export default "__VITE_ASSET__xssBwR3Ikhu9SsYO6gLIMQ__";